import Enum from '/@/modules/core/app/helpers/Enum';
import { getters } from '/@/modules/core/app/helpers/store';
import Lang from '/@/modules/core/app/services/Lang';

export class PartnerMetaBooleanProp extends Enum {
  static HAS_COMMON_LAW_CHILDREN = {
    key: 'hasCommonLawChildren',
    get value() {
      return Lang.t('guidancestep.there-or-has');
    }
  };

  static HAS_COHABITATION_AGREEMENT = {
    key: 'hasCohabitationAgreement',
    get value() {
      return Lang.t('guidancestep.you-and-partner');
    }
  };

  static HAS_JOINT_RESIDENTIAL_PROPERTY = {
    key: 'hasJointResidentialProperty',
    get value() {
      return getters.auth.isClearEstate()
        ? Lang.t('guidancestep.the-mortgage-or')
        : Lang.t('guidancestep.you-jointly-live');
    }
  };

  static HAS_JOINT_INVESTMENT_PROPERTY = {
    key: 'hasJointInvestmentProperty',
    get value() {
      return getters.auth.isClearEstate()
        ? Lang.t('guidancestep.the-owned-residence')
        : Lang.t('guidancestep.you-jointly-than');
    }
  };

  static HAS_JOINT_FINANCIAL_INSTITUTION_ACCOUNT = {
    key: 'hasJointFinancialInstitutionAccount',
    get value() {
      return getters.auth.isClearEstate()
        ? Lang.t('guidancestep.the-union-or')
        : Lang.t('guidancestep.you-card-accounts');
    }
  };

  static DECEASED_IS_BENEFICIARY_OF_LIFE_INSURANCE = {
    key: 'deceasedIsBeneficiaryOfLifeInsurance',
    get value() {
      return Lang.t('guidancestep.the-partner-as');
    }
  };

  static IS_BENEFICIARY_OF_DECEASED_LIFE_INSURANCE = {
    key: 'isBeneficiaryOfDeceasedLifeInsurance',
    get value() {
      return getters.auth.isClearEstate()
        ? Lang.t('guidancestep.the-names-partner')
        : Lang.t('guidancestep.you-yourself-your');
    }
  };

  static OTHER_DOCUMENTARY_EVIDENCE = {
    key: 'otherDocumentaryEvidence',
    get value() {
      return Lang.t('guidancestep.other-documentary-evidence');
    }
  };
}
